import { render, staticRenderFns } from "./InventoryDetails.vue?vue&type=template&id=5641eadd&scoped=true&"
import script from "./InventoryDetails.vue?vue&type=script&lang=js&"
export * from "./InventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetails.vue?vue&type=style&index=0&id=5641eadd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641eadd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5641eadd')) {
      api.createRecord('5641eadd', component.options)
    } else {
      api.reload('5641eadd', component.options)
    }
    module.hot.accept("./InventoryDetails.vue?vue&type=template&id=5641eadd&scoped=true&", function () {
      api.rerender('5641eadd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/InventoryDetails.vue"
export default component.exports